module.exports = __webpack_public_path__ + "static/media/share_weibo.4497b4d6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/share_weibo.svg
 ** module id = 478
 ** module chunks = 0
 **/